import actions from '../../actionTypes';

export default (username, password) => {
  return {
    type: actions.LOG_IN,
    username,
    password
  };
};



// WEBPACK FOOTER //
// ./src/reducers/auth/actions/login.js